<template>
  <a-modal v-model="visible" :title="$t('接口地址')">
    <div slot="footer">
      <a-button type="default" @click="() => visible = false">{{ $t('取消') }}</a-button>
      <a-button type="primary" :loading="loading" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('类型')">
        <a-select v-model="form.type" :options="typeOptions" />
      </a-form-model-item>
      <a-form-model-item :label="$t('接口地址')" prop="apiUrl">
        <a-input v-model="form.apiUrl" />
      </a-form-model-item>
      <a-form-model-item :label="$t('认证接口')" prop="authUrl">
        <a-input v-model="form.authUrl" />
      </a-form-model-item>
      <a-form-model-item :label="$t('用户信息接口')" prop="userInfoUrl">
        <a-input v-model="form.userInfoUrl" />
      </a-form-model-item>
      <a-form-model-item :label="$t('备注')" prop="remark">
        <a-textarea v-model="form.remark" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { saveApiUrl } from '@/api/app/apiurl'

export default {
  data() {
    return {
      visible: false,
      loading: false,
      app: {},
      form: {},
    }
  },
  computed: {
    rules() {
      return {
        type: [
          { required: true, message: this.$t('请选择') }
        ],
        apiUrl: [
          { required: true, message: this.$t('请输入') }
        ],
      }
    },
    typeOptions() {
      return [{ label: this.$t('测试环境'), value: 'dev' }, { label: this.$t('预发布环境'), value: 'beta' }, { label: this.$t('生产环境'), value: 'prod' }]
    }
  },
  methods: {
    show(app, data) {
      this.app = { ...app }
      this.form = { ...data }
      this.visible = true
    },
    handleCommit() {
      this.$refs.form.validate((success, fields) => {
        if (!success) {
          return
        }
        this.loading = true
        const commitData = { ...this.form, appId: this.app.id }
        saveApiUrl(commitData).then(res => {
          if (res.code === 0) {
            this.$emit('ok', commitData)
            this.$message.success(this.$t('保存成功'))
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>